module.exports = __webpack_public_path__ + "static/media/cx.6f47bd14.svg";